<template>
  <v-container>
    <v-row v-if="story != undefined">
      <v-col md="9" sm="6">
        <h1>{{ $t("storyHub.chapterList.listOfChapters") }}</h1>
        <h2>
          {{
            $t("storyHub.chapterList.numberOfChapters", {
              number: story.chapters.length,
            })
          }}
        </h2>
        <v-sheet
          width="100%"
          rounded="xl"
          color="secondaryBackground"
          class="pa-5"
        >
          <v-sheet
            color="transparent"
            v-if="story.chapters && story.chapters.length > 0"
          >
            <ChapterListItem
              v-bind:class="{
                active: activeChapterId == chapter.id,
                outgoing: connectsFromCurrentChapter(chapter.id),
                incoming: connectsToCurrentChapter(chapter.id),
              }"
              :startChapter="startChapter && startChapter.id == chapter.id"
              :chapter="chapter"
              v-for="chapter in story.chapters"
              :key="chapter.id"
              v-on:click.native="setActiveChapterId(chapter.id)"
            />
          </v-sheet>
          <AddChapter :story="story" />
        </v-sheet>
      </v-col>
      <v-col md="3" sm="6">
        <ChapterDetails
          :chapter="activeChapter"
          :startChapter="startChapter && startChapter.id == activeChapter.id"
          :chapters="story.chapters"
        />
      </v-col>
    </v-row>
    <v-row v-else-if="error">
      <h1>{{ $t("storyHub.chapterList.notAuthorizedToEdit") }}</h1>
    </v-row>
  </v-container>
</template>
<script>
import ChapterListItem from "./ChapterListItem";
import ChapterDetails from "./ChapterDetails";
import StoryMutations from "@/graphql/StoryMutations";
import AddChapter from "./AddChapter";
import { mapGetters } from "vuex";
import iris from "@/iris";
export default {
  components: {
    ChapterListItem,
    ChapterDetails,
    AddChapter,
  },
  data() {
    return {
      activeChapterId: null,
      error: undefined,
    };
  },
  apollo: {
    story: {
      query: StoryMutations.getStoryWithChapters,
      variables() {
        return {
          storyId: this.storyIri,
        };
      },
      result({ data }) {
        if (!this.getMe || this.getMe.email != data?.story.owner.email) {
          this.$emit("unauthorized");
        }
      },
      error(error) {
        this.error = error;
      },
      update(data) {
        let sortedChapters = [];
        let story = { ...data.story }
        let chapters = [ ...data.story.chapters];
        let startChapterIndex = null;
        for (let i = 0; i < chapters.length; i++) {
          if (chapters[i].chapterConnectorsTo.length == 0) {
            if (startChapterIndex != null) {
              if (chapters[startChapterIndex].createdAt > chapters[i].createdAt) {
                startChapterIndex = i;
              }
            } else {
              startChapterIndex = i;
            }
          }
        }
        if (startChapterIndex) {
          sortedChapters.push(chapters[startChapterIndex]);
          chapters.splice(startChapterIndex, 1);
        }

        let endChapters = [];

        chapters.sort(function (a, b) {
          return new Date(a.createdAt) - new Date(b.createdAt);
        });

        for (let i = 0; i < chapters.length; i++) {
          const connectors = chapters[i].chapterConnectors
          if (connectors.length == 0) {
            endChapters.push(chapters[i]);
          }
          else {
            sortedChapters.push(chapters[i]);
          }
        }

        for (let i = 0; i < endChapters.length; i++) {
          sortedChapters.push(endChapters[i]);
        }

        story.chapters = sortedChapters;
        return story;
      },
    },
  },
  computed: {
    ...mapGetters("auth", ["getMe"]),
    startChapter() {
      let startChapter = null;
      if (this.story) {
        for (const chapter of this.story.chapters) {
          if (chapter.chapterConnectorsTo.length == 0) {
            if (startChapter) {
              if (startChapter.createdAt > chapter.createdAt) {
                startChapter = chapter;
              }
            } else {
              startChapter = chapter;
            }
          }
        }
      }
      return startChapter;
    },
    storyIri() {
      return `${iris.story}${this.$route.params.id}`;
    },
    activeChapter() {
      if (this.activeChapterId) {
        for (const chapter of this.story.chapters) {
          if (chapter.id == this.activeChapterId) {
            return chapter;
          }
        }
      }
      // if we don't have an active chapter ID, set the first chapter
      if (this.story.chapters[0]) {
        this.setActiveChapterId(this.story.chapters[0].id);
      }
      return this.story.chapters[0];
    },
  },
  methods: {
    connectsFromCurrentChapter(chapterId) {
      for (const chapterConnector of this.activeChapter.chapterConnectors) {
        if (
          chapterConnector.toChapter &&
          chapterConnector.toChapter.id == chapterId
        ) {
          return true;
        }
      }
      return false;
    },
    connectsToCurrentChapter(chapterId) {
      for (const chapterConnector of this.activeChapter.chapterConnectorsTo) {
        if (
          chapterConnector.fromChapter &&
          chapterConnector.fromChapter.id == chapterId
        ) {
          return true;
        }
      }
      return false;
    },
    addNewChapter() {
      this.createChapter(iris.story + this.$route.params.id);
    },
    setActiveChapterId(chapterId) {
      this.activeChapterId = chapterId;
    },
  },
};
</script>
<style scoped lang="scss">
</style>